<template>
  <section>
    <div  class="hero mt-40 mx-25">
      <societe-selector></societe-selector>
      <selecteur-point-de-vente
        :societe-id="societeActiveId"
        @select="actionSelectedPdv" />
      <div class="level mb-10">
        <div class="level-item">
          <div class="has-text-default is-size-14px has-text-centered">{{$t('pointDeVente.ou')}}</div>
        </div>
      </div>
      <div class="level">
        <div class="level-item">
          <b-button type="is-primary"
            class="has-text-weight-bold"
            @click="$router.push({ name: 'creer-point-de-vente' })">
            {{$t('pointDeVente.buttonCreate')}}
          </b-button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { SET_POINT_DE_VENTE, SET_ASSISTANT_ID } from '@/store/modules/recommandations-mutation-type';
import gestionErreur from '@/services/general/gestionErreur';
import enrichirPointDeVente from '@/services/recommandation/enrichirPointDeVente';
import SocieteSelector from '@/components/general/societeSelector';
import SelecteurPointDeVente from '@/components/recommandation/SelecteurPointDeVente';

const Recommandations = createNamespacedHelpers('recommandations');
const Societe = createNamespacedHelpers('societe');

export default {
  components: {
    SocieteSelector,
    SelecteurPointDeVente,
  },
  computed: {
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
  },
  methods: {
    ...Recommandations.mapMutations({
      setPointDeVente: SET_POINT_DE_VENTE,
      setAssistantId: SET_ASSISTANT_ID,
    }),
    async actionSelectedPdv(client) {
      if (!client) return;
      if (!client.tiersParentId) {
        gestionErreur('Le point de vente doit être lié à une enseigne');
        return;
      }
      const loadingComponent = this.$buefy.loading.open({ container: null });
      try {
        this.setPointDeVente(await enrichirPointDeVente(client));
        if (client.assistantId) {
          this.setAssistantId(client.assistantId);
        } else if (client.tiersParent && client.tiersParent.assistantId) {
          this.setAssistantId(client.tiersParent.assistantId);
        }
        this.$router.push({ name: 'creer-panneau' });
      } catch (error) {
        gestionErreur(`Erreur lors de la récupération du client de type point de vente id: ${client.id} selectionné`, error);
        throw error;
      } finally {
        loadingComponent.close();
      }
    },
  },
};
</script>
